import { Controller } from "@hotwired/stimulus";
import tippy from 'tippy.js';

export default class extends Controller {
  static values = {
    content: String,
    theme: { type: String, default: 'light' },
    allowHtml: { type: Boolean, default: false }
  }

  initialize() {
    tippy(this.element, {
      theme: this.themeValue,
      content: this.contentValue || "Content Missing",
      // allowHTML defaults to false: tooltip content is often interpolated from
      // user-controlled fields (e.g. a user's name), so it must be rendered as
      // text, not innerHTML, to avoid stored XSS. See system review §1.6.
      // Only enable it for fully server-built, escaped markup (e.g. the
      // movement charge/qty comparison pills).
      allowHTML: this.allowHtmlValue,
      delay: [100, 0],
      maxWidth: 600,
    });
  }

}
